import React__default from "react";
import classNames from "classnames";
const classPrefix = "nut-safe-area";
const SafeArea = (props) => {
  return React__default.createElement("div", { className: classNames(classPrefix, `${classPrefix}-position-${props.position}`) });
};
export {
  SafeArea as S
};
